import saveSelection from './saveSelection';
import restoreSelection from './restoreSelection';
export var CURSOR_ANCHOR = 'CURSOR_ANCHOR';
export var CURSOR_FOCUS = 'CURSOR_FOCUS';
export default function whileMaintainingSelection(editor, fn) {
  var selection = editor.value.selection;

  if (selection.isUnset || selection.isBlurred) {
    fn(editor.moveToStartOfDocument());
    return editor.deselect();
  }

  var _saveSelection = saveSelection(editor, selection),
      textsSnapshot = _saveSelection.textsSnapshot;

  editor.moveToStartOfDocument();
  fn(editor);

  if (selection.isSet) {
    var _restoreSelection = restoreSelection(editor, selection, textsSnapshot),
        anchor = _restoreSelection.anchor,
        focus = _restoreSelection.focus;

    editor.select(selection.merge({
      anchor: anchor,
      focus: focus
    }));
  } else {
    editor.select(selection);
  }
}